import http from "../../http";

const weapp = {

    getDataMapList(r) {
        return  http.get("/gateway/api/symanage/pc/weappReportDailyPC/getDataMapList",r )
    },
}
export default weapp
